import { render } from "./ControlsRightComponent.vue?vue&type=template&id=3000f406&scoped=true"
import script from "./ControlsRightComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsRightComponent.vue?vue&type=script&lang=ts"

import "./ControlsRightComponent.vue?vue&type=style&index=0&id=3000f406&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3000f406"

export default script